import { request } from '@/requests/default'
import type { SupportQueryTokenResponse } from '@/types/support-query'

export function mintSupportQueryToken(): Promise<SupportQueryTokenResponse> {
  return request<SupportQueryTokenResponse>({
    url: 'api/v1/support/query/token',
    method: 'post',
  })
}
